"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.number.constructor.js");

var _vuePopper = _interopRequireDefault(require("element-ui/lib/utils/vue-popper"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPopper,
      expression: "showPopper"
    }],
    staticClass: "el-dropdown-menu el-popper",
    "class": [_vm.size && "el-dropdown-menu--" + _vm.size],
    style: _vm._px2rem(_vm.style, 24, []),
    attrs: {}
  }, [_vm._t("default", null, {})], 2)]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElDropdownMenu',
  componentName: 'ElDropdownMenu',
  mixins: [_vuePopper["default"]],
  props: {
    visibleArrow: {
      type: Boolean,
      "default": true
    },
    arrowOffset: {
      type: Number,
      "default": 0
    },
    width: {
      type: [String, Number],
      "default": 0
    }
  },
  data: function data() {
    return {
      size: this.dropdown.dropdownSize // style: {
      //   width: typeof this.width === 'number' ? `${this.width}px` : this.width
      // }

    };
  },
  inject: ['dropdown'],
  created: function created() {
    var _this = this;

    this.$on('updatePopper', function () {
      if (_this.showPopper) _this.updatePopper();
    });
    this.$on('visible', function (val) {
      _this.showPopper = val;
    });
  },
  computed: {
    style: function style() {
      var style = {};

      if (this.width) {
        style.width = typeof this.width === 'number' ? "".concat(this.width, "px") : this.width;
      }

      return style;
    }
  },
  mounted: function mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$el;
  },
  watch: {
    'dropdown.placement': {
      immediate: true,
      handler: function handler(val) {
        this.currentPlacement = val;
      }
    }
  }
};
exports["default"] = _default;